import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/builds/ldseating/ldseating-frontend/layouts/default.vue").then(m => m.default || m)),
  none: defineAsyncComponent(() => import("/builds/ldseating/ldseating-frontend/layouts/none.vue").then(m => m.default || m)),
  print: defineAsyncComponent(() => import("/builds/ldseating/ldseating-frontend/layouts/print.vue").then(m => m.default || m))
}